export default {
  API_URL: 'https://peterson-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://petersonsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
